import { render, staticRenderFns } from "./HighLow.vue?vue&type=template&id=2fc9b913&scoped=true"
import script from "./HighLow.vue?vue&type=script&lang=js"
export * from "./HighLow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9b913",
  null
  
)

export default component.exports